module.exports = __webpack_public_path__ + "img/img22.24227886.svg";